import { useState, useRef, useEffect } from 'react';
import { useApp } from '../../context/AppContext';
import { UserPlus, Check, AlertCircle } from 'lucide-react';
import { hapticMedium, hapticError } from '../../utils/haptics';
import { track } from '../../analytics';

export function AddFriendInput() {
  const { sendFriendRequest } = useApp();
  const [handle, setHandle] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [successHandle, setSuccessHandle] = useState<string | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => () => { clearTimeout(timerRef.current); }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccessHandle(null);

    const cleanHandle = handle.trim().replace(/^@/, '');
    if (!cleanHandle) return;

    const err = await sendFriendRequest(cleanHandle);
    if (err) {
      hapticError();
      setError(err);
    } else {
      hapticMedium();
      track('friend_request_sent');
      setSuccessHandle(cleanHandle);
      setHandle('');
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setSuccessHandle(null), 3000);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit} className="flex gap-2">
        <div className="flex-1 relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm">@</span>
          <input
            type="text"
            value={handle}
            onChange={(e) => {
              setHandle(e.target.value);
              setError(null);
            }}
            placeholder="username"
            className="w-full pl-7 pr-3 py-2 text-sm border border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent bg-slate-700 text-slate-100 placeholder-slate-500"
          />
        </div>
        <button
          type="submit"
          className="px-4 py-2 bg-accent text-white text-sm font-medium rounded-lg hover:bg-accent-dark flex items-center gap-1.5"
        >
          <UserPlus size={14} />
          Add
        </button>
      </form>

      {successHandle && (
        <div className="mt-2 flex items-center gap-2 px-3 py-2 rounded-lg border bg-sage/10 border-sage/30 text-sage text-sm animate-slide-down">
          <Check size={14} className="flex-shrink-0" />
          <span>Request sent to @{successHandle}</span>
        </div>
      )}

      {error && (
        <div className="mt-2 flex items-center gap-2 px-3 py-2 rounded-lg border bg-red-500/10 border-red-500/30 text-red-400 text-sm animate-slide-down">
          <AlertCircle size={14} className="flex-shrink-0" />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
}
